"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _autocomplete = require("./utils/autocomplete");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StreetView = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(StreetView, _PureComponent);

  function StreetView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _this.bindRef = function (instance) {
      _this.instance = instance;
    };

    return _this;
  }

  var _proto = StreetView.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        onLoad = _this$props.onLoad,
        latitude = _this$props.latitude,
        longitude = _this$props.longitude,
        pitch = _this$props.pitch,
        zoom = _this$props.zoom,
        yaw = _this$props.yaw;
    (0, _autocomplete.createStreetView)(this.instance, {
      latitude: latitude,
      longitude: longitude,
      pitch: pitch,
      zoom: zoom,
      yaw: yaw
    }).then(onLoad);
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: this.props.className,
      ref: this.bindRef
    });
  };

  return StreetView;
}(_react.PureComponent);

exports["default"] = StreetView;
StreetView.propTypes = {
  onLoad: _propTypes["default"].func,
  latitude: _propTypes["default"].number,
  longitude: _propTypes["default"].number,
  pitch: _propTypes["default"].number,
  zoom: _propTypes["default"].number,
  yaw: _propTypes["default"].number,
  className: _propTypes["default"].string
};
StreetView.defaultProps = {
  onLoad: _noop2["default"]
};